import request from "../plugins/request";

// 获取系统设置信息
export const getSettingsInfo = () => {
  return request({
    url: '/api/settings/getSettingsInfo',
    method: 'get'
  })
}

// 基本设置
export const setBaseSettings = (data) => {
  return request({
    url: '/api/settings/setBaseSettings',
    method: 'post',
    data: data
  })
}

// 预警设置
export const setWarningSettings = (data) => {
  return request({
    url: '/api/settings/setWarningSettings',
    method: 'post',
    data: data
  })
}

// 检查更新
export const checkUpdate = () => {
  return request({
    url: '/api/settings/checkUpdate',
    method: 'post'
  })
}

// 更新系统
export const updateVersion = (data) => {
  return request({
    url: '/api/settings/updateVersion',
    method: 'post',
    data: data
  })
}

// 用户列表-分页
export const getEmployeeListPage = (data) => {
  return request({
    url: '/api/employee/getEmployeeListPage',
    method: 'post',
    data: data
  })
}

// 编辑用户信息
export const editEmployee = (data) => {
  return request({
    url: '/api/employee/editEmployee',
    method: 'post',
    data: data
  })
}

// 新增用户
export const addEmployee = (data) => {
  return request({
    url: '/api/employee/addEmployee',
    method: 'post',
    data: data
  })
}

// 删除用户
export const deleteEmployee = (params) => {
  return request({
    url: '/api/employee/deleteEmployee',
    method: 'get',
    params
  })
}

// 获取区域负责人列表（网格员）
export const getGridList = (params) => {
  return request({
    url: '/api/employee/getGridList',
    method: 'get',
    params
  })
}
